import { Trans, useTranslation } from "react-i18next";
import OktaAuth from "@okta/okta-auth-js";

import { useConfigContext } from "shared/contexts/ConfigContext";

import Button from "features/components/Button";
import Card from "features/components/Card";
import Typography from "features/components/Typography";

interface Props {
  oktaAuth: OktaAuth;
}

const AccessForbidden = ({ oktaAuth }: Props) => {
  const { t } = useTranslation();
  const { general } = useConfigContext();
  const supportEmail = general?.helpContactEmail;

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Card className="text-center">
        <Typography variant="h1" className="text-red-600 mb-4">
          {t("common:auth.access_forbidden_title")}
        </Typography>
        <div className="text-gray-600 mb-5">
          {t("common:auth.access_forbidden_message")}
          {supportEmail && (
            <>
              <br />
              <Trans
                t={t}
                i18nKey="common:auth.access_forbidden_contact"
                values={{ email: supportEmail }}
                components={{ email: <a href={`mailto:${supportEmail}`} /> }}
              />
            </>
          )}
        </div>
        <Button
          variant="contained"
          size="small"
          onClick={() => oktaAuth.signOut()}
        >
          {t("common:auth.sign_out")}
        </Button>
      </Card>
    </div>
  );
};
export default AccessForbidden;
